module.exports = __webpack_public_path__ + "img/team-5.77f5794e.png";